import React from "react";
import "../Styles/Referrals.css";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import api from '../Component/Api';

function Referrals() {

      const user = useSelector((state) => state.auth.user);

const [referralActivity, setReferralActivity] = useState([]);

useEffect(() => {
  const fetchReferralData = async () => {
    const { data } = await api.get("/referral-dashboard");
    console.log("Referral Dashboard Data:", data);
    setReferralActivity(data.activity);
   
  };

  fetchReferralData();
}, []);
  return (
    <div className="referrals-page">

      {/* Header */}
      <div className="referrals-header">
        <div>
          <p className="referrals-eyebrow">REFERRALS</p>

          <h1>Earn by sharing ClusterClear.</h1>

          <p className="referrals-subtitle">
            Share your referral link and earn £5 for every wristband purchased
            through you.
          </p>
        </div>
      </div>

      {/* Referral link */}
      <section className="referral-link-card">

        <div className="referral-link-content">
          <span className="referral-label">
            YOUR REFERRAL LINK
          </span>

          <div className="referral-link-row">
            <div className="referral-link">
              www.clusterclear.app/product?ref=${user?.referralCode}
            </div>

            <button
              className="copy-referral-button"
              onClick={() => {
                navigator.clipboard.writeText(
                  "https://clusterclear.app/?ref=CC8F42K1"
                );
              }}
            >
              Copy link
            </button>
          </div>

          <p className="referral-link-description">
            Anyone who purchases through this link will be connected to your
            referral account.
          </p>
        </div>

      </section>

      {/* Earnings */}
      <div className="referral-stats">

        <div className="referral-stat-card">
          <span className="referral-stat-label">
            Available to withdraw
          </span>

          <strong>{user?.referralWallet.available}</strong>

          <p>Ready to withdraw</p>
        </div>

        <div className="referral-stat-card">
          <span className="referral-stat-label">
            Pending
          </span>

          <strong>{user?.referralWallet.pending}</strong>

          <p>Released after delivery</p>
        </div>

        <div className="referral-stat-card">
          <span className="referral-stat-label">
            Lifetime earnings
          </span>

          <strong>{user?.referralWallet.lifetimeEarned}</strong>

          <p>Total earned from referrals</p>
        </div>

        <div className="referral-stat-card">
          <span className="referral-stat-label">
            Items sold
          </span>

          <strong>{user?.referralWallet.itemsSold}</strong>

          <p>Wristbands referred</p>
        </div>

      </div>

      {/* Main content */}
      <div className="referrals-grid">

        {/* Activity */}
        <section className="referrals-card">

          <div className="referrals-card-header">
            <div>
              <h2>Referral activity</h2>
              <p>Your latest referred purchases</p>
            </div>
          </div>

         <div className="referral-activity-list">
  {referralActivity.length === 0 ? (
    <div className="referral-empty-state">
      <div className="referral-empty-icon">🎁</div>

      <h3>No referral activity yet</h3>

      <p>
        Share your referral link with friends, creators, or business owners.
        Every successful wristband purchase will appear here.
      </p>
    </div>
  ) : (
    referralActivity.map((item, index) => (
      <div
        className="referral-activity-item"
        key={`${item.code}-${index}`}
      >
        <div className="referral-activity-icon">£</div>

        <div className="referral-activity-info">
          <strong>{item.name}</strong>

          <span>
            {item.code} · {item.date}
          </span>
        </div>

        <div className="referral-activity-right">
          <strong>{item.amount}</strong>

          <span
            className={`referral-status ${
              item.status === "Pending" ? "pending" : "available"
            }`}
          >
            {item.status}
          </span>
        </div>
      </div>
    ))
  )}
</div>

        </section>

        {/* How it works */}
        <section className="referrals-card how-referrals-card">

          <div className="referrals-card-header">
            <div>
              <h2>How it works</h2>
              <p>Earn from every successful referral</p>
            </div>
          </div>

          <div className="referral-steps">

            <div className="referral-step">

              <div className="referral-step-number">
                01
              </div>

              <div>
                <strong>Share your link</strong>

                <p>
                  Send your personal ClusterClear referral link to someone
                  who would benefit from a wristband.
                </p>
              </div>

            </div>

            <div className="referral-step">

              <div className="referral-step-number">
                02
              </div>

              <div>
                <strong>They purchase</strong>

                <p>
                  When they complete a wristband purchase through your link,
                  the referral is recorded automatically.
                </p>
              </div>

            </div>

            <div className="referral-step">

              <div className="referral-step-number">
                03
              </div>

              <div>
                <strong>You earn £5</strong>

                <p>
                  Your £5 reward is added to your referral balance and becomes
                  available after the order is delivered.
                </p>
              </div>

            </div>

          </div>

        </section>

      </div>

      {/* Withdrawal */}
      <section className="withdrawal-card">

        <div>
          <span className="withdrawal-label">
            AVAILABLE BALANCE
          </span>

          <strong>{user?.referralWallet.available}</strong>

          <p>
            Your available referral earnings can be withdrawn once eligible.
          </p>
        </div>

        <button
          className="withdraw-button"
          disabled
        >
          Withdraw earnings
        </button>

      </section>

    </div>
  );
}

export default Referrals;